import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const BoogieWoogieLogo = () => (
  <StaticImage
    src='../../images/boogie-woogie-logo-white.png'
    alt='Dandy Lines Boogie-Woogie Logo'
    placeholder='tracedSVG'
  />
);

export default BoogieWoogieLogo;
